// extracted by mini-css-extract-plugin
export var eventsguideContainer = "events-guide-module--eventsguideContainer--2880a";
export var fullSize = "events-guide-module--fullSize--88e5f";
export var resultColumnContainer = "events-guide-module--resultColumnContainer--063b9";
export var resultContainer = "events-guide-module--resultContainer--bd207";
export var resultListContainer = "events-guide-module--resultListContainer--1b763";